import React from "react";
import "./ComparePanel.css";

/**
 * Painel reutilizavel de comparacao entre datas.
 *
 * Props:
 *  - items      : Array<{ dateLabel: string }>
 *  - indexA     : number (indice selecionado para Momento A)
 *  - indexB     : number (indice selecionado para Momento B)
 *  - onChangeA  : (index: number) => void
 *  - onChangeB  : (index: number) => void
 *  - children   : ReactNode (conteudo extra, ex: toggle A/B)
 */
export default function ComparePanel({
  items,
  indexA,
  indexB,
  onChangeA,
  onChangeB,
  children
}) {
  return (
    <div className="compare-panel compare-panel--overlay">
      <div className="compare-panel__select-wrap">
        <label htmlFor="compare-select-a">Momento A</label>
        <select
          id="compare-select-a"
          className="compare-panel__select"
          value={indexA}
          onChange={e => onChangeA(Number(e.target.value))}
        >
          {items.map((item, i) => (
            <option key={i} value={i}>
              {item.dateLabel}
            </option>
          ))}
        </select>
      </div>

      {children}

      <div className="compare-panel__select-wrap">
        <label htmlFor="compare-select-b">Momento B</label>
        <select
          id="compare-select-b"
          className="compare-panel__select"
          value={indexB}
          onChange={e => onChangeB(Number(e.target.value))}
        >
          {items.map((item, i) => (
            <option key={i} value={i}>
              {item.dateLabel}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
